export const ActionTypes = {
    SET_TASK_RULES: 'SET_TASK_RULES',
    SET_TASK_RULE: 'SET_TASK_RULE',
    SET_TASK_RULE_ACTIONS: 'SET_TASK_RULE_ACTIONS',
    SET_TASK_RULE_NOTIFICATIONS: 'SET_TASK_RULE_NOTIFICATIONS'
  };
